import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { indicadorAlertaPermanencia } from '../../../modal/indicadorAlertaPermanencia';
import { StatusIndicadorAlerta } from '../../../utilidades/enum/status.indicador.alerta.enum';
import { posto_simple } from '../../../modal/posto_simple';
import { mensagem } from '../../../modal/mensagem';
import { DateTimeFormatPipe } from '../../../utilidades/date-time-format.pipe';
import { TimeFormatPipe } from '../../../utilidades/time-format.pipe';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import html2canvas from 'html2canvas';
import { FormControl, FormsModule } from '@angular/forms';
import * as ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { StatusCorIndicadorAlerta } from '../../../utilidades/enum/status.cor.indicardor.alerta.enum';
import $ from 'jquery'; // Import jQuery
import { MultipleSelectionSelectAllComponent } from '../../../utilidades/multiple-selection-select-all/multiple-selection-select-all.component';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PostoService } from '../../../service/posto.service';
import { RegiaoService } from '../../../service/regiao.service';
import { logosBase64 } from '../../../utilidades/logosBase64'
import { Console } from 'console';
import { RelatorioService } from '../../../service/relatorio.service';
import { PostoPonto } from '../../../utilidades/interfaceRelatorioPontoAtendimento';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import FileSaver from 'file-saver';
import { ChartModule } from 'primeng/chart'
import { PostoGrafico } from '../../../utilidades/interfaceRelatorioGraficoJustificativa';
import { ChartData } from 'chart.js';
@Component({
  selector: 'app-grafico-justificativa',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    FormsModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    ChartModule,
    MultipleSelectionSelectAllComponent,
    MatFormFieldModule, MatDatepickerModule
  ],
  templateUrl: './grafico-justificativa.component.html',
  styleUrl: './grafico-justificativa.component.scss',
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    TimeFormatPipe, DateTimeFormatPipe, provideNativeDateAdapter()]
})


export class graficoJustificativaComponent implements OnInit {
  public SemDados: boolean = false;
  larguraTela: number = window.innerWidth;
  login: string | null | undefined = null;
  dataMensagem = [];
  listaPostos: any = [];
  pesquisaDataInit: string = "";
  listaRegiao: any = [];
  RegiaoSelecionada: any;
  PostosSelecionados: any[] = [];
  usuario: any;
  feitaPesquisa: boolean = true;
  chartsData: ChartData<'line'>[] = [];
  options: any[] = [];
  TextoCab = "";

  logosEsquerda: any[] = [];
  logosDireita: any[] = [];

  constructor(private route: ActivatedRoute, private router: Router, private _logosBase64: logosBase64,
    private relatorioService: RelatorioService, @Inject(DOCUMENT) private document: Document,
    private postoService: PostoService, private regiaoService: RegiaoService,
    public timeFormatPipe: TimeFormatPipe,
    public dateTimeFormatPipe: DateTimeFormatPipe) {
    try {
      const localStorage = document.defaultView?.localStorage;
      if (localStorage)
        this.login = localStorage.getItem('login');
      if (this.login == null || this.login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
  }


  ngOnInit() {
    let login = localStorage.getItem('login');
    this.usuario = localStorage.getItem('salaSituacao');
    this.listarPostos();
    this._logosBase64.carregarLogos();

    this._logosBase64.logosEsquerda$.subscribe(data => {
        this.logosEsquerda = data;
    });

    this._logosBase64.logosDireita$.subscribe(data => {
        this.logosDireita = data;
    });
  }
  processarInfo(info: any) {
    this.PostosSelecionados = info;
  }

  getTotalAtendimentos(ponto: any): number {
    return ponto.pontosAtendimentos.reduce((sum: number, pa: any) => sum + pa.atendimentos.length, 0);
  }

  listarPostos() {
    let sala: any = localStorage.getItem('salaSituacao');
    sala = JSON.parse(sala);
    this.postoService.getPostoUsuario(this.usuario).pipe().subscribe((result: any) => {
      result.Posto.forEach((posto: any) => {
        this.listaPostos.push(posto);
      });

      this.listaPostos.sort(function (a: any, b: any) {
        if (a.descricao > b.descricao) {
          return 1;
        }
        if (a.descricao < b.descricao) {
          return -1;
        }
        return 0;
      })
    })
  }

  onSelecionar(valor: string) {
    this.RegiaoSelecionada = valor; // Atualiza o valor quando o select muda
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.larguraTela = window.innerWidth;
  }

  Pesquisa() {
    this.TextoCab ="";
    this.options = [];
    const horas: string[] = [];

    this.chartsData = [];
    if (this.PostosSelecionados.length != 0) {
      this.feitaPesquisa = false;
      var retrievedObject = localStorage.getItem('salaSituacao');
      if (retrievedObject != null) {
        var sala = JSON.parse(retrievedObject);
        var millis: number | null = null;
        if (this.pesquisaDataInit != "" && this.pesquisaDataInit != undefined) {
          const dateObject = new Date(this.pesquisaDataInit); // Converte a string para um objeto Date
          millis = dateObject.getTime();
        }
        this.relatorioService.getRelatorioGraficoJustificativa(sala['postos'], this.PostosSelecionados.toString(), 6, millis).pipe(
        ).subscribe((response: PostoGrafico[]) => {
          console.log(response);
          if (response.length == 0)
          {
            this.disbledBotao = false;
            this.SemDados = true;
          }
          else {
            var data = "";
            if (millis != null)
              data = this.dateTimeFormatPipe.transformSemHoraEDiaDaSemana(millis);
            this.TextoCab = response[0].descricao + " - " + data;
            var hourInicio: number = 0;
            var hourFim: number = 0;

            if (response[0].horaAbertura.includes(":")) {
              hourInicio = parseInt(response[0].horaAbertura.split(":")[0], 10) - 1;
            }
            else {
              hourInicio = parseInt(response[0].horaAbertura.substring(0, 2)) - 1;
            }

            if (response[0].horaAbertura.includes(":")) {
              hourFim = parseInt(response[0].horaFechamento.split(":")[0], 10) + 1;
            }
            else {
              hourFim = parseInt(response[0].horaFechamento.substring(0, 2)) + 1;
            }
            for (let h = hourInicio; h < hourFim; h++) {
              const start = h.toString().padStart(2, '0') + ':00';
              const end = (h + 1).toString().padStart(2, '0') + ':00';
              horas.push(`${start}-${end}`);
            }

            this.SemDados = false;

            for (let index = 0; index < response.length; index++) {
              const element = response[index];

              // inicia dataset com zeros
              const dataset = Array(horas.length).fill(0);

              element.diasGraficos.forEach(diasGraf => {
                const date = new Date(diasGraf.dia);
                
                const hora = date.getHours();
                const horaFormatada = `${hora}:00`;
                const i = hora - hourInicio;
                if (i >= 0 && i < horas.length) {
                  dataset[i] = diasGraf.quantidadeJustificativa;
                }
              });

              // monta config do gráfico desse elemento
              const chartData: ChartData<'line'> = {
                labels: horas,
                datasets: [
                  {
                    label: 'Quantidade de incidências',
                    data: dataset,
                    backgroundColor: 'rgba(66, 165, 245, 0.2)',
                    borderColor: '#42A5F5',
                    fill: true,
                    tension: 0.4,
                  }
                ]
              };

              var op = {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: 'top',
                    display: false
                  },
                  title: {
                    display: true,
                    text: '' + element.descricaoFila
                  }
                },
                scales: {
                  y: {
                    beginAtZero: true
                  }
                }
              };

              this.options.push(op);
              // adiciona na lista de gráficos
              this.chartsData.push(chartData);
            }
            this.disbledBotao = false;
          }
        });
      }
      else{
        this.disbledBotao = false;
      }
    }
    else {
      this.disbledBotao = false;
      this.feitaPesquisa = true;
      this.chartsData = [];
    }
  }
  disbledBotao = false;
  filtrarPesquisa() {
    this.disbledBotao = true;
    this.Pesquisa();
  }

  formatDate(value: number | string): string {
    if (value == null || value == "") {
      return "";
    }
    const date = new Date(value);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getLetterFromNumber(num: number): string {
    const baseCharCode = 'A'.charCodeAt(0); // Código ASCII para 'A'
    return String.fromCharCode(baseCharCode + num - 1);
  }

  getTodayDate(): string {
    const date = new Date();
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  formatMillis(millis: number): string {
    if (!millis || millis < 0) return '0min';

    // total de minutos (arredondado para cima)
    const totalMinutes = Math.ceil(millis / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}min`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${minutes}min`;
    }
  }

  formatMillisSoMin(millis: number): string {
    if (!millis || millis < 0) return '0min';

    return "" + Math.floor(millis / (1000 * 60));
  }


}